import { CompassCardUI } from '@scale/compass-ui/types';
import {
  SquadActionsCardShared,
  type SquadActionsContextSchemaType,
  type SquadActionsContext,
  SQUAD_ACTIONS,
} from '@scale/genai-compass-shared/cards/squad_actions';
import { faUsers } from '@fortawesome/pro-solid-svg-icons';
import SquadActionsCardComponent from 'react-scale/corp/views/DataCompassCardsV2/action/SquadActionsCard/SquadActionsCardComponent';

const defaultContext: SquadActionsContext = {
  cardType: SQUAD_ACTIONS,
  squadIdColumn: '',
  userIdColumn: '',
  actionColumn: '',
};

export const SquadActionsCardInfo: CompassCardUI<SquadActionsContextSchemaType> = {
  ...SquadActionsCardShared,
  title: 'Squad Actions',
  icon: 'users',
  toolTip: 'Add or remove users to or from a squad.',
  defaultContext,
  showOutput: true,
  button: {
    icon: faUsers,
  },
  legacyComponent: SquadActionsCardComponent,
};
